// Últimas ferramentas clicadas no menu do header, persistidas no localStorage.
// Guardamos por nome (as regras especiais do menu — modais, chatbot, links
// externos — já são keyed por nome) e resolvemos contra a lista atual da API
// na exibição, descartando ferramentas removidas/renomeadas.
const KEY = 'conlicitacao_recent_tools';

// Guarda mais do que exibe (o menu mostra 3) para ter reserva caso alguma
// ferramenta recente saia da lista/permissão do cliente.
const MAX_STORED = 6;

export const getRecentTools = (): string[] => {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((n) => typeof n === 'string') : [];
  } catch {
    return [];
  }
};

export const registerRecentTool = (name: string): void => {
  try {
    const list = [name, ...getRecentTools().filter((n) => n !== name)].slice(0, MAX_STORED);
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // ignore (localStorage indisponível)
  }
};
